export default {
  getBoleto: state => id => state.boletos.find(boleto => boleto.id === id),
}
